
export default {
    spacingDebug: false,
    components: {
        CloseButton: () => import("~/components/global/CloseButton"),
    },
    props: {
        modal_id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: "Coming Soon",
        },
        description: {
            type: String,
            default: "Stay tuned for updates!",
        },
        shortdescription: {
            type: Boolean,
            default: false,
        },
        logo: {
            type: Boolean,
            default: true,
        },
        subtitle: {
            type: String,
            default: "",
        },
        button_action: {
            type: String,
            default: "travel",
        },
        button: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toggleCloseDialog(modalId) {
            if (!this.$parent.modals) return;
            const modal = this.$parent.modals.find((m) => m.id === modalId);
            if (!modal) return;
            modal.show = false;
            document.body.classList.remove("no_scroll");
            const header = document.querySelector(".__n");
            if (header) {
                header.style.zIndex = "10";
            }
        },
    },
    mounted() {
        document.body.classList.add("no_scroll");
        const header = document.querySelector(".__n");
        if (header) {
            header.style.zIndex = "2";
        }
    },
};
